import React from 'react';

const SimpleCollapse: React.FC<{
    title?: React.ReactNode;
    /**
     * Rendered beside the title, outside the toggle button. Use it for controls
     * that must stay independently clickable — links nested inside the button
     * would be invalid markup and would also toggle the collapse.
     */
    titleAdornment?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
    defaultExpanded?: boolean;
}> = ({
    children,
    className = 'color-grey-800',
    title = '',
    titleAdornment,
    defaultExpanded = false,
}) => {
    const [collapsed, setCollapsed] = React.useState(!defaultExpanded);

    const toggle = (
        <button
            className={`btn btn-link p-l5-0 font-l5 font-l5--small text-decoration-none text-start ${className}`}
            onClick={() => setCollapsed(!collapsed)}
            type="button"
        >
            {title}
        </button>
    );

    return (
        <div className={collapsed ? 'd-inline-block' : 'd-block'} translate="no">
            {titleAdornment ? (
                <div className="d-flex align-items-center gap-1">
                    {toggle}
                    {titleAdornment}
                </div>
            ) : (
                toggle
            )}
            {/* Mount the body only while expanded, so a collapsed section's
                children (and any work they do on render) cost nothing. */}
            {!collapsed && <div className="mt-l5-4">{children}</div>}
        </div>
    );
};

export default SimpleCollapse;
